import React from "react";
import Translate from "react-translate-component";
export const CommittyMemberCreate = ({
  op,
  linkToAccount,
  fromComponent
}) => {
  return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Translate, {
    component: "span",
    content: fromComponent === "proposed_operation" ? "proposal.committee_member_create" : "transaction.committee_member_create"
  }), "\xA0", linkToAccount(op[1].committee_member_account));
};